export default __webpack_public_path__ + "static/media/icon_download1.a01a830c.svg";